import {api} from './apiSlice';

export const receiptApiSlice = api.injectEndpoints({
  endpoints: (build) => ({
    receiptApiSlice: build.mutation({
      async queryFn({formType, claimId}, _queryApi, _extraOptions, fetchWithBaseQuery) {
        const options = {
          url: formType === 'intake' ? '/print_intake_form' : '/print_release_form',
          method: 'POST',
          body: JSON.stringify({claim_id: claimId}),
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/html',
          },
          responseHandler: 'text',
        };

        const response = await fetchWithBaseQuery(options);

        if (response.error) {
          return {error: response.error};
        }

        return {data: response.data};
      },
    }),
  }),
  overrideExisting: false,
});

export const {useReceiptApiSliceMutation} = receiptApiSlice;
